import {Injectable} from '@angular/core';
import {DataStorageService} from './data-storage.service';
import {Setting} from '../models/setting.model';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class SendEmailService {

    emailTypeOptions = {
        '1': 'confirm', '2': 'register'
        , '3': 'contact from customer'
        , '4': 'edit reservation contact'
        , '5': 'Reset Password'
        , '6': 'Receipt'
        , '7': 'Bulk to Sub Agencies'
        , '8': 'Bulk to EndDate Changed Routes Related Passengers'
    };

    setting: Setting;

    email_from: string;
    email_to: string;
    name_from = 'OZShuttle Services';
    subject: string;
    message: string;

    email_bcc: string[];
    private uniqueEmails: any[];

    constructor(private http: HttpClient, private dataStorageService: DataStorageService) {
        this.email_bcc = [];
    }

    initEmail(obj) {
        console.log(obj);
        this.dataStorageService.fetchSetting().subscribe(
            (setting) => {
                this.setting = setting;
                this.email_from = this.setting.company_email;
                this.email_to = obj.email_to;
                this.message = `<table width="650">
                                    <tr>
                                        <td>` + this.setting.text_email_header + `</td>
                                    </tr>
                                    <tr>
                                        <td><table cellpadding="20"><tr><td>`;
                switch (obj.type) {
                    case 1 :
                        this.message = this.message.replace('%title', 'OZshuttle Reservation Confirmation');
                        this.subject = 'Your OZShuttle Booking Confirmation';
                        this.message +=
                            this.setting.text_email_confirm;
                        this.message += '' +
                            `<table cellpadding="5" width="610">
                                <tr bgcolor="#ececec">
                                    <td> Name(s) </td>
                                    <td>`;
                        let i = 0;
                        for (const passenger of obj.reservation.passenger) {
                            this.message += '' +
                                passenger.last_name + `, ` + passenger.first_name;
                            if (i !== obj.reservation.passenger.length) {
                                this.message += '<br>';
                            }
                            i++;
                        }
                        this.message += '' +
                            `</td>
                                </tr>
                                <tr>
                                    <td> Reservation # </td>
                                    <td>` + obj.reservation.reservation_no + `</td>
                                </tr>
                                <tr bgcolor="#ececec">
                                    <td> Dep. Date </td>
                                    <td>` + obj.reservation.ticket.date +
                            `<br> Departure Status: ` +
                            (obj.reservation.status === 'canceled' ? '<span style="color: red; font-weight: bold;">Canceled</span>' :
                                obj.reservation.status === 'pending' ? '<span style="color: red; font-weight: bold;">Pending</span>' :
                                    (obj.reservation.ticket.status === 'blocked') ? '<span style="color: red; font-weight: bold;">WaitListed</span>' :
                                        `<span style="color: black; font-weight: bold;">${obj.reservation.status.charAt(0).toUpperCase() + obj.reservation.status.slice(1)}</span>`) +
                            `<br> Departure Time: ` + obj.reservation.ticket.route.pick_time +
                            `<br> Departure Point: ` + obj.reservation.ticket.route.pick_stop.title +
                            `<br> Estimated Arrival Time at ` + obj.reservation.ticket.route.drop_stop.title + `: ` +
                            obj.reservation.ticket.route.drop_time +
                            `</td>
                                </tr>`;
                        if (obj.reservation.ticket_re) {
                            this.message += '' +
                                `<tr>
                                    <td> Arr. Date </td>
                                    <td>` + obj.reservation.ticket_re.date +
                                `<br> Departure Status: ` +
                                (obj.reservation.status === 'canceled' ? '<span style="color: red; font-weight: bold;">Canceled</span>' :
                                    obj.reservation.status === 'pending' ? '<span style="color: red; font-weight: bold;">Pending</span>' :
                                        (obj.reservation.ticket_re.status === 'blocked') ? '<span style="color: red; font-weight: bold;">WaitListed</span>' :
                                            `<span style="color: black; font-weight: bold;">${obj.reservation.ticket_re.status.charAt(0).toUpperCase() + obj.reservation.ticket_re.status.slice(1)}</span>`) +
                                `<br> Departure Time: ` + obj.reservation.ticket_re.route.pick_time +
                                `<br> Departure Point: ` + obj.reservation.ticket_re.route.pick_stop.title +
                                `<br> Estimated Arrival Time at ` + obj.reservation.ticket_re.route.drop_stop.title + `: ` +
                                obj.reservation.ticket_re.route.drop_time +
                                `</td>
                                </tr>`;
                        }
                        this.message += '' +
                            `</table>
                            <br>
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td align="center">
                                        <a style="padding: 8px 12px; border: #64bc46 solid 1px;border-radius: 4px; font-size: 14px; color: #ffffff;
                                        background-color: #64bc46;
                                        text-decoration: none; font-weight:bold; display: inline-block;" href="https://ozshuttle.com/#/pages/coupon/` + obj.reservation.id + `">You must click to print your coupon</a>
                                    </td>
                                </tr>
                            </table>
                            `;
                        break;
                    case 2 :
                        this.message = this.message.replace('%title', 'OZShuttle Agency Registration');
                        this.subject = 'Agency Registration Form';
                        this.message += this.setting.text_email_register;
                        break;
                    case 3 :
                        this.subject = 'Contact from Customer : ' + obj.subject;
                        this.message += obj.content;
                        this.email_from = obj.email_from;
                        this.email_to = 'info@ihanatour.com';
                        this.name_from = obj.name;
                        break;
                    case 4 :
                        this.subject = obj.subject;
                        this.message += obj.content;
                        break;
                    case 5 :
                        // reset password
                        this.message = this.message.replace('%title', 'OZshuttle Reset Password');
                        this.subject = 'Reset Password';
                        this.email_from = 'info@ihanatour.com';
                        this.email_to = obj.email_to;
                        this.message += '<table width="100%" border="0" cellspacing="0" cellpadding="0">\n' +
                            '                                <tr>\n' +
                            '                                    <td align="center">\n' +
                            '                                       <p>We received a request to change your Square account password. To reset your password, press the "Reset Password" button below within 24 hours. </p>\n' +
                            '                                       <br>\n' +
                            '                                        <a style="padding: 8px 12px; border: #64bc46 solid 1px;border-radius: 4px; font-size: 14px; color: #ffffff;\n' +
                            '                                        background-color: #64bc46;\n' +
                            '                                        text-decoration: none; font-weight:bold; display: inline-block;" href="https://admin.ozshuttle.com/#/authentication/reset-password;%token">Reset Password</a>\n' +
                            '                                       <br>\n' +
                            '                                       <p>If you did not request this Password Reset you can disregard this message and your password will remain unchanged. </p>\n' +
                            '                                       <br>\n' +
                            '                                       <p>Thanks, </p>\n' +
                            '                                       <br>\n' +
                            '                                       <p>Oz Shuttle Team</p>\n' +
                            '                                    </td>\n' +
                            '                                </tr>\n' +
                            '                            </table>';
                        break;
                    case 6 :
                        // send receipt
                        this.message = this.message.replace('%title', 'OZshuttle Receipt');
                        this.subject = 'Shuttle Receipt';
                        this.email_from = 'info@ihanatour.com';
                        this.email_to = obj.email_to;
                        this.message += '<table width="100%" border="0" cellspacing="0" cellpadding="0">\n' +
                            '                                <tr>\n' +
                            '                                    <td align="center">\n' +
                            '                                       <p>Please find the receipt below. </p>\n' +
                            '                                    </td>\n' +
                            '                                </tr>\n' +
                            '                            </table>';
                        this.message += '' +
                            `<table cellpadding="5" width="610">
                                <tr bgcolor="#ececec">
                                    <td> Name(s) </td>
                                    <td>`;
                        let z = 0;
                        for (const passenger of obj.reservation.passenger) {
                            this.message += '' +
                                passenger.last_name + `, ` + passenger.first_name;
                            if (z !== obj.reservation.passenger.length) {
                                this.message += '<br>';
                            }
                            z++;
                        }
                        this.message += '    ' +
                            `        </td>
                                </tr>
                                <tr>
                                    <td> Reservation # </td>
                                    <td>` + obj.reservation.reservation_no + `</td>
                                </tr>
                                <tr bgcolor="#ececec">
                                    <td> Dep. Date </td>
                                    <td>` + obj.reservation.ticket.date +
                            `<br> Departure Time: ` + obj.reservation.ticket.route.pick_time +
                            `<br> Departure Point: ` + obj.reservation.ticket.route.pick_stop.title +
                            `<br> Estimated Arrival Time at ` + obj.reservation.ticket.route.drop_stop.title + `: ` +
                            obj.reservation.ticket.route.drop_time +
                            `</td>
                                </tr>`;
                        if (obj.reservation.ticket_re) {
                            this.message += '' +
                                `<tr>
                                    <td> Arr. Date </td>
                                    <td>` + obj.reservation.ticket_re.date +
                                `<br> Departure Time: ` + obj.reservation.ticket_re.route.pick_time +
                                `<br> Departure Point: ` + obj.reservation.ticket_re.route.pick_stop.title +
                                `<br> Estimated Arrival Time at ` + obj.reservation.ticket_re.route.drop_stop.title + `: ` +
                                obj.reservation.ticket_re.route.drop_time +
                                `
                                    </td>
                                </tr>`;
                        }
                        this.message += '' +
                            `<tr>
                                    <td> Amount Paid </td>
                                    <td>`;
                        let k = 0;
                        if (obj.reservation.payment) {
                            for (const payment of obj.reservation.payment) {
                                this.message += '$' +
                                    payment.amount + ` (` + payment.type + `)`;
                                if (k !== obj.reservation.payment.length) {
                                    this.message += '<br>';
                                }
                                k++;
                            }
                        }
                        this.message += '' +
                            `</td>
                                </tr>
                            </table>
                            <br>
                            `;
                        this.message += '<table width="100%" border="0" cellspacing="0" cellpadding="0">\n' +
                            '                                <tr>\n' +
                            '                                    <td align="center">\n' +
                            '                                        <a style="padding: 8px 12px; border: #64bc46 solid 1px;border-radius: 4px; font-size: 14px; color: #ffffff;\n' +
                            '                                        background-color: #64bc46;\n' +
                            '                                        text-decoration: none; font-weight:bold; display: inline-block;" href="https://ozshuttle.com/#/pages/receipt/\n' + obj.reservation.id + '">Print Receipt</a>\n' +
                            '                                       <br>\n' +
                            '                                       <p>Thank you for your business, </p>\n' +
                            '                                       <br>\n' +
                            '                                       <p>OZshuttle Team</p>\n' +
                            '                                    </td>\n' +
                            '                            </table>';
                        break;
                    case 7:
                        // bulk email to sub agencies and customer
                        this.message = this.message.replace('%title', 'OZshuttle Notification');
                        this.subject = obj.subject;
                        this.email_from = 'info@ihanatour.com';
                        this.email_to = obj.email_to;
                        this.email_bcc = obj.email_bcc;
                        this.message += obj.content;
                        break;
                    case 8:
                        // bulk email to passengers related to end_date changed route reservation
                        this.message = this.message.replace('%title', 'OZShuttle Schedule Change Notification');
                        this.subject = 'OZShuttle Schedule Change Notification';
                        this.email_from = 'info@ihanatour.com';
                        this.email_to = obj.email_to;
                        this.message += `
                                        <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td align="center">
                                                    <p>
                                                        Your schedule has been changed because the place is under construction.
                                                        Please check your new schedule.
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>`;
                        this.message += `
                                        <table cellpadding="5" width="610">
                                            <tr bgcolor="#ececec">
                                                <td> Name(s) </td>
                                                <td>`;
                        let j = 0;
                        for (const passenger of obj.reservation.passenger) {
                            this.message += '' +
                                passenger.last_name + `, ` + passenger.first_name;
                            if (j !== obj.reservation.passenger.length - 1) {
                                this.message += '<br>';
                            }
                            j++;
                        }
                        this.message += `
                                                </td>
                                            </tr>
                                            <tr>
                                                <td> Reservation # </td>
                                                <td>`;
                        if (obj.reservation.reservation_no) {
                            this.message += obj.reservation.reservation_no;
                        }
                        this.message += `
                                                </td>
                                            </tr>
                                            <tr bgcolor="#ececec">
                                                <td> New Stop </td>
                                                <td>` + obj.new_stop + ` ( ` + obj.new_time + ` ) ` + `</td>
                                            </tr>
                                        </table>
                            <br>
                            `;
                        this.message += '<table width="100%" border="0" cellspacing="0" cellpadding="0">\n' +
                            '                                <tr>\n' +
                            '                                    <td align="center">\n' +
                            '                                        <a style="padding: 8px 12px; border: #64bc46 solid 1px;border-radius: 4px; font-size: 14px; color: #ffffff;\n' +
                            '                                        background-color: #64bc46;\n' +
                            '                                        text-decoration: none; font-weight:bold; display: inline-block;" href="https://ozshuttle.com/#/pages/coupon/' + obj.reservation.id + '">Print Coupon</a>' +
                            '                                       <br>\n' +
                            '                                       <p>Thank you for your business, </p>\n' +
                            '                                       <br>\n' +
                            '                                       <p>OZShuttle Team</p>\n' +
                            '                                    </td>\n' +
                            '                            </table>';
                        // this.email_to = 'wldbsle@gmail.com';
                        break;
                    case 9:
                        // bulk email to passengers related to date changed route reservation
                        this.message = this.message.replace('%title', 'OZShuttle Schedule Change Notification');
                        this.subject = 'OZShuttle Schedule Change Notification';
                        this.email_from = 'info@ihanatour.com';
                        this.email_to = obj.email_to;
                        this.message += `
                                        <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td align="center">
                                                    <p>
                                                        Your schedule has been changed because of the flight schedule.
                                                        Please check your new schedule.
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>`;
                        this.message += `
                                        <table cellpadding="5" width="610">
                                            <tr bgcolor="#ececec">
                                                <td> Name(s) </td>
                                                <td>`;
                        let p = 0;
                        for (const passenger of obj.reservation.passenger) {
                            this.message += '' +
                                passenger.last_name + `, ` + passenger.first_name;
                            if (p !== obj.reservation.passenger.length - 1) {
                                this.message += '<br>';
                            }
                            p++;
                        }
                        this.message += `
                                                </td>
                                            </tr>
                                            <tr>
                                                <td> Reservation # </td>
                                                <td>`;
                        if (obj.reservation.reservation_no) {
                            this.message += obj.reservation.reservation_no;
                        }
                        this.message += `
                                                </td>
                                            </tr>
                                            <tr bgcolor="#ececec">
                                                <td> New Schedule </td>
                                                <td>` + obj.schedule + `</td>
                                            </tr>
                                        </table>
                            <br>
                            `;
                        this.message += '<table width="100%" border="0" cellspacing="0" cellpadding="0">\n' +
                            '                                <tr>\n' +
                            '                                    <td align="center">\n' +
                            '                                        <a style="padding: 8px 12px; border: #64bc46 solid 1px;border-radius: 4px; font-size: 14px; color: #ffffff;\n' +
                            '                                        background-color: #64bc46;\n' +
                            '                                        text-decoration: none; font-weight:bold; display: inline-block;" href="https://ozshuttle.com/#/pages/coupon/' + obj.reservation.id + '">Print Coupon</a>' +
                            '                                       <br>\n' +
                            '                                       <p>Thank you for your business, </p>\n' +
                            '                                       <br>\n' +
                            '                                       <p>OZShuttle Team</p>\n' +
                            '                                    </td>\n' +
                            '                            </table>';
                        // this.email_to = 'jiyoon@ihanatour.com';
                        break;
                }
                this.message += `</td></tr></table></td>
                            </tr>
                            <tr>
                                <td>` + this.setting.text_email_footer + `</td>
                            </tr>
                        </table>`;
                if (+obj.type === 5) {
                    this.sendEmailWithUserId();
                } else {
                    this.sendEmail();
                }
            },
            (err) => {
                console.error(err);
            }
        );
    }

    sendEmail() {
        const emailObj = {
            email_from: this.email_from,
            email_to: this.email_to,
            email_bcc: this.email_bcc,
            name_from: this.name_from,
            subject: this.subject,
            message: this.message
        };
        this.http.post('https://shuttle.ihanatour.com/backend/api/extras/send_email_2.php', emailObj)
            .subscribe(response => {
                if (response) {
                    if (response['error']) {
                        alert('Sending Email Failed. ');
                    }
                } else {
                    alert('Email sent. ');
                    // location.reload();
                }
            });
    }

    sendEmailWithUserId() {
        const emailObj = {
            email_from: this.email_from,
            email_to: this.email_to,
            name_from: this.name_from,
            subject: this.subject,
            message: this.message
        };
        this.http.post('https://shuttle.ihanatour.com/backend/api/user/send_reset_password_req.php', emailObj)
            .subscribe(response => {
                if (response) {
                    if (response['error']) {
                        alert('Sending Email Failed. ');
                    }
                } else {
                    alert('Email sent. ');
                    // location.reload();
                }
            });
    }
    setUniqueEmails(emails:any []): void {
        this.uniqueEmails = emails;
    }

    getUniqueEmails(): any[] {
        return this.uniqueEmails;
    }
}
